<template>
  <accessDetails></accessDetails>
</template>

<script>
import AccessDetails from "@/components/MasterSetup/accessrules/AccessruleDetails"
export default {
    components:{
        AccessDetails
    }
}
</script>

<style>

</style>